import React from 'react';
import { AED_DISPLAY_SIGN_CHAR, AED_CURRENCY_CODE } from '@/constants/uaDirhamDisplay';

type Props = {
  /** 'inlineSvg' = vector; 'text' = Unicode U+20C3 (may show tofu without font) */
  variant?: 'inlineSvg' | 'text';
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
};

const InlineGlyph: React.FC<{ className?: string; style?: React.CSSProperties; 'aria-label'?: string }> = ({
  className,
  style,
  'aria-label': ariaLabel = 'AED',
}) => (
  <span className={className} style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 1, ...style }} role="img" aria-label={ariaLabel} title={AED_CURRENCY_CODE}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 16"
      fill="currentColor"
      aria-hidden
      style={{ width: '0.9em', height: '0.9em', verticalAlign: 'middle' }}
    >
      <path d="M1 1.5h4.2C8.2 1.5 10 3.3 10 5.5S8.2 9.5 5.2 9.5H1V1.5zm0 8h3.2c2.3 0 3.5 1.1 3.5 2.5S6.5 15 4.2 15H1v-5.5z" />
      <line x1="0" y1="6" x2="11" y2="6" stroke="currentColor" strokeWidth="1.1" />
      <line x1="0" y1="8.2" x2="11" y2="8.2" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  </span>
);

/**
 * UAE dirham sign for display (AED = ISO; this is the symbol only). Use with Statistic prefix/suffix; use formatCurrency for amounts.
 */
export const AedDirhamSign: React.FC<Props> = ({ variant = 'inlineSvg', className, style, 'aria-label': ariaLabel = 'AED' }) => {
  if (variant === 'text') {
    return (
      <span className={className} style={style} title={AED_CURRENCY_CODE} role="img" aria-label={ariaLabel}>
        {AED_DISPLAY_SIGN_CHAR}
      </span>
    );
  }
  return <InlineGlyph className={className} style={style} aria-label={ariaLabel} />;
};
